<template>
  <div>
    <!-- Tabbed privacy consent -->
    <tabs
      :tab-name="tabNames"
      class="privcay_consent_tabs"
      color-button="success"
      ref="privacy"
      @show-script="showScript"
      v-model="privacy_consent.consent_type"
      :disabled="is_disabled"
      title="Privacy Consent"
      :disabled-tabs="disabledTabs"
      action-button-text="Send Privacy request via email"
      second-action-button-text="Send Privacy request via sms"
      @clickActionButton="onClickActionButton"
      @secondClickActionButton="onClickSecondActionButton"
      :isLoading="isSendingPrivacy"
    >

        <!-- Skip Veda -->
        <template slot="tab-pane-1">
          <div class="md-layout">
            <p>Privacy consent not given, skipping veda report.</p>
          </div>
        </template>

        <!-- Written -->
        <template slot="tab-pane-2">
          <div class="md-layout">
            <p><b>You are obligated to upload and attach the written privacy to this application.</b></p>
          </div>
        </template>

        <!-- Digital -->
        <template slot="tab-pane-3">
          <div class="md-layout">
            <p>Digital privacy consent given.</p>
          </div>
        </template>
    </tabs>
    <md-dialog-alert
      :md-active.sync="dialog_script.show"
      :md-title="dialog_script.title"
      :md-content="dialog_script.content"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import ValidatedInputs from '@/components/ValidatedInput';
import Tabs from "@/components/Tabs";
import EditApplicantVedaReport from "./EditApplicantVedaReport";
import LoadingIconTextButton from '@/components/LoadingIconTextButton';
import AlertDialog from '@/components/Dialogs/AlertDialog'
import WaitingDialog from '@/components/Dialogs/WaitingDialog'

export default {
  components: {
    ...ValidatedInputs,
    Tabs,
    EditApplicantVedaReport,
    LoadingIconTextButton,
    AlertDialog,
    WaitingDialog,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    index: {
      required: true,
      default: 0,
  },
    privacy_consent: {
      type: Object,
      required: true,
    },
    disabled: {
      required: false,
      default: false,
    },
    version: {
        type: String,
        required: true,
    }
  },
  data() {
    return {
      dialog_script: {
        show: false,
        title: '',
        content: '',
      },
      displayScript: false,
      loading: false,
      isSendingPrivacy: false,
      enableDigital: false,
      disabledTabs: ['Digital', 'Written'],
      requestStatus: {
        sms: true,
        email: true,
      },
      successfulMessage: '<span style="color:green;font-weight:bold;">Successful</span>',
      failedMessage: '<span style="color:red;font-weight:bold;">Failed</span>',
    };
  },
  mounted() {
    if (this.applicant && (this.privacy_consent.has_expired && this.version == 'Current')) {
      this.privacy_consent.consent_type = "Not Given";
    }
    this.getDisabledTabs();
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      "options",
      "application",
      "userHasRole",
    ]),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() { return this.value },
      set(applicant) { this.$emit('input', applicant) },
    },
    is_disabled() {
      if (this.disabled) {
        return true;
      }
      //consent types in which it should be locked
      let consentType = ['Digital', 'Verbal', 'Written'];
      let is_locked_consent = consentType.includes(this.privacy_consent.consent_type);
      //if the consent type for the application is in the array above and if the veda report is already fetched do not allow them to change the consent type
      if ((this.applicant.veda_report && this.applicant.veda_report.success && is_locked_consent) || this.hasConsentInHubspot) {
        // If privacy consent has expired, allow for change in consent.
        if (this.privacy_consent.has_expired) {
          return false
        }
        return true;
      }
      return false;
    },
    //new computed func to check hubspot date as its easy to understand from the name
    hasConsentInHubspot() {
      let hasConsentInHubspot = this.privacy_consent.hubspot_privacy_accepted_date ?? null;
      if (hasConsentInHubspot) {
        return true;
      }
      return false;
    },
    tabNames() {
        let tabNames = [];
        if (this.options.privacy_consent_type_options !== undefined) {
            tabNames = this.options.privacy_consent_type_options;
            if (tabNames.length) {
                tabNames = tabNames.filter((tabName) => tabName !== 'Verbal');
            }
        }
        return tabNames;
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    showScript() {
      if (this.disabled) {
        return false;
      }
      this.displayScript = !this.displayScript;
      this.dialog_script.title = "Broker or agent to read the following script to client before proceeding";
      this.dialog_script.content = '<p>In order to process this or any application for credit it is necessary for Aus Loans to collect, use and disclose personal information about you. ' +
        'Your personal information will be dealt with by Aus Loans in accordance with it’s Privacy Consent, Credit Guide, Credit Quote and Privacy Policy. ' +
        'You can obtain the Privacy Consent, Credit Guide, Credit Quote and Privacy Policy of Aus Loans by going to its website ' +
        '<a href="http://www.ausloans.com.au/privacy-consent">www.ausloans.com.au/privacy-consent</a></p><br />' +
        '<p>Aus Loans require your authority to obtain credit information from a credit reporting agency. ' +
        'Disclosure of personal information may include lenders such as, Pepper, Secure Funding Pty Ltd, Latitude Financial Services, ' +
        'AMMF, Now Finance, Money3, Finance One, Firstmac, Automotive Financial Services, Gedda Money. ' +
        'Green Light Auto Finance, Metro Finance, FlexFleet , Westpac, Grow Asset Finance, Plenti, WISR, Azora Asset Finance and Affordable Car Loans. ' +
        'This may also include disclosing personal information to a credit repair agency to assist with obtaining finance.</p><br />' +
        '<p>Before providing you with credit assistance or services we must provide you with a credit quote to advise you what we may charge.' +
        'The maximum fee payable to Aus Loans is up to $2,500, the average fee payable is $990.' +
        'Your broker will advise the exact cost of the fee payable upon approval of your application.' +
        'The fee we may charge for credit assistance can be financed with your contract and there will be no cost to you unless your application proceeds to settlement.</p><br />' +
        '<p>Do you accept the credit quote consent to Aus Loans: </p>' +
        '<p> · Obtaining credit information and information derived from it, from the credit reporting body Equifax; for the purposes of assessing an application from you for consumer or commercial credit?</p>' +
        '<p> · Disclosing personal information about you, including identity particulars and the amount of credit applied for in this application?</p>' +
        '<p> · Recording your verbal acceptance with a digital signature?</p>';
      this.dialog_script.show = true;
    },
    async saveApplication () {
      let savingApplicationSuccessful = false;
      try {
        this.$modal.show(WaitingDialog, {
          "title": "Saving application...",
          "message": "Please wait while saving application."
        })
        savingApplicationSuccessful = await this.$store.dispatch("save_application", this.application);
        this.$modal.submit();
      } catch (error) {
        this.$modal.submit();
        this.$modal.show(AlertDialog, {
          "title": "Failed saving application",
          "message": "Application didn't save, and privacy request didn't send."
        });
      }
      return savingApplicationSuccessful;
    },
    async onClickActionButton(){
      if (await this.saveApplication()) {
        this.setOnlineToRequested()
        this.isSendingPrivacy = true;
        await this.sendEmail();
        this.isSendingPrivacy = false;
        const emailResult = this.requestStatus.email ? this.successfulMessage : this.failedMessage;
        const emailMessage = '<li> Send Privacy Request via Email - ' + emailResult + '</li>';
        this.showRequestResult(
          emailMessage,
          !this.requestStatus.email
        );
        // redirect after saving
        this.$store.commit("redirect_after_save", this.application);
      }
    },
    async onClickSecondActionButton() {
      if (await this.saveApplication()) {
        this.setOnlineToRequested()
        this.isSendingPrivacy = true;
        await this.sendSms();
        this.isSendingPrivacy = false;
        const smsResult = this.requestStatus.sms ? this.successfulMessage : this.failedMessage;
        const smsMessage = '<li> Send Privacy Request via SMS - ' + smsResult + '</li>';
        this.showRequestResult(
          smsMessage,
          !this.requestStatus.sms
        );
        // redirect after saving
        this.$store.commit("redirect_after_save", this.application);
      }
    },
    setOnlineToRequested() {
      let foundIndex = -1;

      for (let i = 0; i < this.applicant.document_requests.length; i++) {
        // ID of online request = 46
        if (this.applicant.document_requests[i].id === 46) {
          foundIndex = i;
        }
      }

      if (foundIndex !== -1) {
        // Set online privacy request to true
        this.applicant.document_requests[foundIndex].requested = true;
      } else {
        console.error('Online request could not be updated')
      }
    },
    async sendEmail() {
      try {
        this.$modal.show(WaitingDialog, {
          "title": "Sending document request via email...",
          "message": "Please wait while the email is being sent to applicant..."
        });
        await this.$store.dispatch("request_documents_via_email", {
          application_data: this.application,
          applicantId: this.applicant.id,
          document_requests: this.applicant.document_requests,
          generateLink: false,
          onApplicationPage: true
        });
        this.requestStatus.email = true;
      } catch (error) {
        this.requestStatus.email = false;
      } finally {
        this.$modal.submit();
      }
    },
    async sendSms() {
      try {
        this.$modal.show(WaitingDialog, {
          "title": "Sending document request via sms...",
          "message": "Please wait while the sms is being sent to applicant..."
        });
        await this.$store.dispatch("request_documents_via_sms", {
          application_data: this.application,
          applicantId: this.applicant.id,
          generateLink:true,
          onApplicationPage: true,
        });
        this.requestStatus.sms = true;
      } catch (error) {
        this.requestStatus.sms = false;
      } finally {
        this.$modal.submit();
      }
    },
    showRequestResult (resultMessage, showFailedNotification) {
      let message = '<ul>' + resultMessage + '</ul>';
      if (showFailedNotification) {
        message += '<span style="color:red;font-weight:bold;">' +
                    "Please check all fields are valid and save the application before retrying. Contact support if issue persists." +
                  '</span>';
      }
      this.showDialogPopup(
        "Document Request status",
        message,
      )
    },
    showDialogPopup(title, message) {
      this.dialog_script.title = title;
      this.dialog_script.content = message;
      this.dialog_script.show = true;
    },
    applicationChange(){
      this.$emit('application-change')
      this.loading = false;
    },
    getDisabledTabs() {
      if (this.applicant) {
        switch(this.privacy_consent.consent_type) {
          case 'Digital':
            if (!this.userHasRole('super-admin')) {
              this.disabledTabs = ['Not Given', 'Verbal', 'Written'];
            } else {
              this.disabledTabs = ['Verbal', 'Written'];
            }
            break;
          case 'Written':
            if (!this.userHasRole('super-admin')) {
              this.disabledTabs = ['Not Given', 'Digital', 'Verbal'];
            } else {
              this.disabledTabs = ['Digital', 'Verbal'];
            }
            break;
          case 'Not Given':
          case 'Verbal':
          default:
            this.disabledTabs = ['Digital', 'Written'];
            break;
        }
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'privacy_consent_type_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>

<style scoped>
  .privcay_consent_tabs {
    min-height: 0px;
  }

  .md-subheader {
    display: flex;
    justify-content: space-between;
  }

</style>
